<template>
  <div>
    <notifications position="bottom left" :duration="5000" style="width: calc(100% - 56px)" />
    <notifications group="error" :duration="10000"
                   position="bottom left" style="width: calc(100% - 56px)" />
    <notifications group="sw:updatefound" position="top left" style="width: 100%">
      <template #body="{ item, close }">
        <div class="vue-notification --sys" @click="close" @contextmenu="close">
          <Button class="btn--act" splash @click="item.data.onConfirm">Reload!</Button>
          <div class="notification-title">New version found!</div>
          <div class="notification-content">Updates will be applied after reload.</div>
        </div>
      </template>
    </notifications>
  </div>
</template>
<style>

.vue-notification {
  z-index: var(--zi-notify, 200);
  font-size: 18px;
  padding: calc(var(--page-pad) * .75) var(--page-pad);

  &.success a {
    color: var(--white);
    text-decoration: underline;
  }

  &.error > * {
    color: var(--white) !important;
  }

  &-group &-wrapper:first-child .error {
    border-top-right-radius: 50px;

    &:after {
      content: '🐛';
      position: absolute;
      right: 0;
      top: -11px;
      font-size: 48px;
      filter: hue-rotate(308deg);
      animation: hue-rotate 5s infinite linear;
    }
  }

  &.--sys {
    margin: 0 0 4px;


    button {
      float: right;
      color: white;
      border-color: white;
      background: transparent;
    }
  }
}
</style>